import { css } from 'styled-components';

export default function getGenericColorGrid(colors: NonNullable<string[]>) {
    const sq = Math.sqrt(colors.length);
    const remainder = sq % 1;
    const equalGrid = !remainder;

    if (!equalGrid) {
        if (colors.length < 4) {
            return css`
                grid-template-columns: repeat(auto-fill, ${`${100 / 2}%`});
                grid-template-rows: 1fr;
            `;
        }

        return getGenericColorGrid(colors.filter((x, i) => i < colors.length - 1));
    }

    return css`
        grid-template-columns: repeat(auto-fill, ${`${100 / sq}%`});
        grid-template-rows: repeat(auto-fill, ${`${100 / sq}%`});
    `;
}
